import React, { useCallback, useState } from 'react';
import { IProductInsideCombo } from 'src/types/combo';
import { IProduct } from 'src/types/products';
import ComboItem from '../../components/ComboItem/ComboItem';
import { ICurrentMealGroup } from '../MealComboItemsBlock/MealComboItemsBlock';
import MealComboItemModal from '../../components/MealComboItemModal/MealComboItemModal';
import { localeStore } from 'src/mobx/localesStore';
import '../DealComboItemsBlock/style.scss';
import './style.scss';

interface IProps {
  product?: IProduct;
  groups: ICurrentMealGroup[];
  selectItem: (item: IProductInsideCombo) => void;
}

const MealComboItemsModals: React.FC<IProps> = (props: IProps): JSX.Element => {
  const [currentItemIndex, setCurrentItemIndex] = useState<number | null>(null);
  const [selectedGroupItems, setSelectedGroupItems] = useState<IProductInsideCombo[] | null>(null);

  const handleClose = (event?: React.MouseEvent<HTMLUListElement>) => {
    if (
      !event ||
      (event?.target as HTMLUListElement)?.classList.contains('hide-scrollbar') ||
      (event?.target as HTMLDivElement)?.classList.contains('icon-close')
    ) {
      setSelectedGroupItems(null);
    }
  };

  const handleSelectItem = (item: IProductInsideCombo) => {
    props.selectItem(item);
    handleClose();
  };

  const itemClickHanler = useCallback(
    (item: IProductInsideCombo) => {
      const selectedGroup: ICurrentMealGroup | undefined = props.groups.find((group) => group.id === item.group_id);
      if (selectedGroup) {
        setCurrentItemIndex(0);
        setSelectedGroupItems(selectedGroup.items);
      }
    },
    [props.groups]
  );

  const handleUpdateIndex = (index: number) => {
    setCurrentItemIndex(index);
  };

  const currentSelectItems: IProductInsideCombo[] = props.groups.reduce(
    (sum: IProductInsideCombo[], current: ICurrentMealGroup) =>
      sum.concat(current.items.filter((item) => item.is_selected) || []),
    []
  );

  return (
    <>
      <ul className="deal-combo-items-block__wrapper d-flex flex-column">
        {currentSelectItems.map((item) => (
          <ComboItem
            key={item.id}
            item={item}
            selectItem={itemClickHanler}
            clickOnItem={itemClickHanler}
            type={props.product?.type}
          />
        ))}
      </ul>
      {selectedGroupItems?.length ? (
        <div className="meal-combo-items-carousel__wrapper">
          <ul className="meal-combo-items-carousel hide-scrollbar animation slideup" onClick={handleClose}>
            {selectedGroupItems.map((item, index) => (
              <MealComboItemModal
                index={index}
                curentUndex={currentItemIndex}
                item={item}
                updateCurrentIndex={handleUpdateIndex}
                selectItem={handleSelectItem}
                close={handleClose}
              />
            ))}
          </ul>
          <p className="meal-combo-items-carousel__counter pxmt-4">{`${
            (selectedGroupItems.findIndex((item) => item.is_selected) || 0) + 1
          } ${localeStore.t('of')} ${selectedGroupItems.length}`}</p>
        </div>
      ) : null}
    </>
  );
};

export default MealComboItemsModals;
